import { useLocalStore } from 'mobx-react-lite';

import { IcCalendarIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IPopoverMenuItem } from '@gem/ui-kit';

import Entities from 'STORE';

import { scheduleTextMessage } from '../../Tasks/scheduleTextMessage';
import { scheduleVoiceMessage } from '../../Tasks/scheduleVoiceMessage';

type TSetDisabledHandler = (isDisabled: boolean) => void;

interface ISubmitButtonMenuPresenter {
  isVoiceMode: boolean;
  menuItems: IPopoverMenuItem[];
  onMessageSchedule(): Promise<void>;
}

export const useSubmitButtonMenuPresenter = (
  onSetDisabled: TSetDisabledHandler
): ISubmitButtonMenuPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalStore<ISubmitButtonMenuPresenter>(() => ({
    get isVoiceMode(): boolean {
      const inputPanel = Entities.InputPanelsStore.activeInputPanel;
      if (!inputPanel) {
        return false;
      }

      return Boolean(inputPanel.voice?.isRecording || inputPanel.voice?.isPreviewMode);
    },

    get menuItems(): IPopoverMenuItem[] {
      return [
        {
          key: 'scheduleMessage',
          icon: IcCalendarIcon,
          title: t('schedule_message'),
          onClick: presenter.onMessageSchedule,
          isVisible: true,
        },
      ];
    },

    async onMessageSchedule(): Promise<void> {
      const group = Entities.GroupsStore.activeGroup;
      if (!group) {
        return;
      }

      if (presenter.isVoiceMode) {
        await scheduleVoiceMessage(group.id);
      } else {
        await scheduleTextMessage(group.id);
      }
    },
  }));

  return presenter;
};
